import React, { useState, useEffect, useCallback } from 'react';
/* Added the following code for ray_menuStructure.ray using AI Agent. 16 Jul 2026. Code Start */
import { createRoot } from 'react-dom/client';
/* Code end. ray using AI Agent. 16 Jul 2026 */
import App from './components/App.jsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { BASE_URL } from "./config";
import axios from "axios";
import { MenuPathProvider } from "./context/MenuPathContext";
import { BlockPermissionProvider } from "./context/BlockPermissionContext";
/* Commenting the following code for FAST.Ray using AI Agent. 23/07/2026. Comment Start */
// Monaco CDN config moved into Compiler / CodeEditor2 so it loads only when editors mount.
// import { loader } from "@monaco-editor/react";
// loader.config({
//   paths: {
//     vs: "https://unpkg.com/monaco-editor@0.55.1/min/vs",
//   },
// });
/* Commenting end. Ray using AI Agent. 23/07/2026 */

const RootComponent = () => {
  const [permissions, setPermissions] = useState([]);
  const [routeAccess, setRouteAccess] = useState([]);
  const [navLoading, setNavLoading] = useState(
    () => !!localStorage.getItem("token")
  );
  const fetchPermissions = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setNavLoading(false);
      return;
    }

    setNavLoading(true);
    try {
      const response = await axios.get(
        BASE_URL + `/api/user/user-nav-headers-new`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setPermissions(response.data.navheaders);
        setRouteAccess(response.data.route_access);
        // Store route_access in localStorage for components to check block permissions
        localStorage.setItem("route_access", JSON.stringify(response.data.route_access));
      }
    } catch (error) {
      /* Added the following code for ray_menuStructure.ray using AI Agent. 16 Jul 2026. Code Start */
      // Clear stale JWT so /home does not load with a token the backend rejects (403).
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("route_access");
        setPermissions([]);
        setRouteAccess([]);
        if (window.location.pathname.startsWith("/home")) {
          window.location.href = "/login";
        }
      }
      /* Code end. ray using AI Agent. 16 Jul 2026 */
      console.log("Error fetching permissions:", error);
    } finally {
      setNavLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchPermissions();
  }, [fetchPermissions]);

  /* Added the following code for ray_menustructure.ray using AI Agent. 2026-06-18. Code Start */
  useEffect(() => {
    const onAuthLogin = () => fetchPermissions();
    window.addEventListener("auth-login", onAuthLogin);
    return () => window.removeEventListener("auth-login", onAuthLogin);
  }, [fetchPermissions]);
  /* Code end. ray using AI Agent. 2026-06-18 */

  return (
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true }}>
      <MenuPathProvider>
        <BlockPermissionProvider>
          <Toaster position='top-right' />
          <App
            access={permissions}
            isRoutePermits={routeAccess}
            refreshNav={fetchPermissions}
            navLoading={navLoading}
          />
        </BlockPermissionProvider>
      </MenuPathProvider>
    </BrowserRouter>
  </React.StrictMode>
  );
};

/* Added the following code for ray_menuStructure.ray using AI Agent. 16 Jul 2026. Code Start */
createRoot(document.getElementById('root')).render(
  <RootComponent />
);
/* Code end. ray using AI Agent. 16 Jul 2026 */
